<template>
  <div class="intro-illustration-content" id="identidade-visual-ilustracao-introducao" data-search-anchor>
    <div class="illustration-video-player">
      <AutoPlayVideo :src="videoSrc" height="344px"/>
    </div>

    <div class="description-illustration-content">
      <p class="intro-illustration-description">{{ introDescription }}</p>
      <p class="intro-illustration-description">{{ introDescription1 }}</p>
      <p class="intro-illustration-description">{{ introDescription2 }}</p>
      <p class="intro-illustration-description">{{ introDescription3 }}</p>
    </div>
    <div class="button-illustration-wrapper">
      <RedirectOneDriveButton
          :linkUrl="onedriveUrl"
          buttonText="Baixar ilustrações"
      />      
    </div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import IllustrationPageMixin from '@/mixins/illustration-page-mixin'
import { IllustrationPageStore } from '@/store/visual-identity-page/illustration-store'
import { Component, Mixins, Ref } from 'vue-property-decorator'
import { applyHighlightAndWatch } from '@/core/searchHighlight'
import { getModule } from 'vuex-module-decorators'
import AutoPlayVideo from '@/components/AutoPlayVideo.vue'

@Component({
  components: {
    AutoPlayVideo
  }
})
export default class IllustrationIntroSection extends Mixins(IllustrationPageMixin) {
  illustrationPageStore: PageStoreContract = getModule(IllustrationPageStore, this.$store)

  onedriveUrl = 'https://tvglobocorp.sharepoint.com/sites/intranetconexao/DocumentosMarca/Ilustra%C3%A7%C3%B5es'

  get introDescription(): string {
    return this.getElementText(1, 0)
  }

  get introDescription1(): string {
    return this.getElementText(1, 1)
  }

  get introDescription2(): string {
    return this.getElementText(1, 2)
  }

  get introDescription3(): string {
    return this.getElementText(1, 3)
  }  

  @Ref('videoElement') readonly videoElement!: HTMLVideoElement
  @Ref('videoWrapper') readonly videoWrapper!: HTMLVideoElement

  get videoSrc(): string {
    return this.getElementMedia(1, 0)
  }

  async getIllustrationPage(): Promise<void> {
    await this.illustrationPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.illustrationPageStore.isLoading) {
      await this.getIllustrationPage()
    }
    const query = (this.$route.query.q as string) || ''
    if (query) {
      this.$nextTick(() => {
        applyHighlightAndWatch(query)
      })
    }
  }
}
</script>

<style lang="scss">
.intro-illustration-content {  
  display: grid;
  grid-template-columns: 50% 50%;

  width: 100%;
  max-width: 1032px;
}

.description-illustration-content {
  width: 488px;
  
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.button-illustration-wrapper {
  display: flex;
  align-items: center;
  padding-top: 2rem;
}
</style>
